import Vuetify from 'vuetify/lib';
import Vue from 'vue';
// Note: use only relative paths, using @/ will cause an error when installed
import vuetifyConfig from './vuetify.config';
import { reducer } from './vuetify.config';
import ClickOutside from 'vue-click-outside';
import highlightFilter from '../src/filters/highlightFilter';
import '../src/scss/global.scss';

import {
  VAlert,
  VApp,
  VAutocomplete,
  VBtn,
  VBottomSheet,
  VSheet,
  VBtnToggle,
  VCard,
  VCol,
  VContainer,
  VCheckbox,
  VChip,
  VDialog,
  VDivider,
  VForm,
  VHover,
  VIcon,
  VLayout,
  VList,
  VListItem,
  VListItemGroup,
  VListItemTitle,
  VMenu,
  VProgressCircular,
  VProgressLinear,
  VRow,
  VSnackbar,
  VStepper,
  VStepperContent,
  VStepperItems,
  VStepperStep,
  VSwitch,
  VSubheader,
  VTextarea,
  VSelect,
  VTextField,
  VTooltip,
  VBadge,
  VRadioGroup,
  VRadio,
  VTabs,
  VTab,
  VTabsItems,
  VTabItem,
  VBreadcrumbs,
  VColorPicker,
  VExpansionPanels,
  VExpansionPanel,
  VExpansionPanelHeader,
  VExpansionPanelContent,
  VSkeletonLoader,
  VTimeline,
  VTimelineItem,
  VOverlay,
  VDataTable,
  VDatePicker,
} from 'vuetify/lib/components';
// import initI18n from "./initI18n";
import svgImages from './svgImages';
// todo: change all above import to the next line import so we won't import all vuetify component
// import VAlert from 'vuetify/lib/components/VAlert'\

Vue.use(Vuetify, {
  components: {
    VAlert,
    VApp,
    VAutocomplete,
    VBtn,
    VBottomSheet,
    VSheet,
    VBtnToggle,
    VCard,
    VCol,
    VContainer,
    VCheckbox,
    VChip,
    VDialog,
    VDivider,
    VForm,
    VHover,
    VIcon,
    VLayout,
    VList,
    VListItem,
    VListItemGroup,
    VListItemTitle,
    VMenu,
    VProgressCircular,
    VProgressLinear,
    VRow,
    VStepper,
    VStepperContent,
    VStepperItems,
    VStepperStep,
    VSnackbar,
    VSubheader,
    VSwitch,
    VTextarea,
    VSelect,
    VTextField,
    VTooltip,
    VBadge,
    VRadioGroup,
    VRadio,
    VTabs,
    VTab,
    VTabsItems,
    VTabItem,
    VBreadcrumbs,
    VColorPicker,
    VExpansionPanels,
    VExpansionPanel,
    VExpansionPanelHeader,
    VExpansionPanelContent,
    VSkeletonLoader,
    VTimeline,
    VTimelineItem,
    VOverlay,
    VDataTable,
    VDatePicker,
  },
});

// Register common directives
Vue.directive('ds-click-outside', ClickOutside);

// Register common filters
Vue.filter('dsHighlight', highlightFilter);

const DesignSystem = ({ theme = {}, options = {}, extIcons = {} } = {}, locale = 'en') => {
  const ds = { ...(Vue.prototype.$ds || {}), ...options };
  // Make the options available to all the components
  Vue.prototype.$ds = ds;
  Vue.prototype.$log = Vue.prototype.$log || console.log;
  Vue.prototype.$svgImages = Vue.prototype.$svgImages || svgImages;

  const DSIcons = vuetifyConfig.icons;

  const iconsArray = Object.keys(extIcons).reduce((acc, key) => reducer(acc, key, extIcons), {});

  const icons = {
    icons: {
      ...DSIcons,
      values: {
        ...DSIcons.values,
        ...iconsArray,
      },
    },
  };

  const vuetifyConfigOverride = {
    ...vuetifyConfig,
    ...theme,
    ...icons,
    rtl: window.direction === 'rtl',
  };
  // initI18n(locale);
  return new Vuetify(vuetifyConfigOverride);
};

export default DesignSystem;
